
import { mapActions } from 'vuex'
import api from '~/api/' // server

export default {
    name: 'DetailListUnderDirectBanking',
    props: {
        params: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            form: {
                DEPOSITOR: '',
                ISSUE_TYPE: '',
                ISSUE_NUMBER: '',
            },
        }
    },
    watch: {
        params() {
            this.getBoardDetail()
        },
    },

    created() {
        this.getBoardDetail()
    },

    destroyed() {
        this.form = {
            DEPOSITOR: '',
            ISSUE_TYPE: '',
            ISSUE_NUMBER: '',
        }
    },

    methods: {
        ...mapActions('modal', ['SHOW_ALERT']),

        async getBoardDetail() {
            const params = {
                ...this.params,
            }

            const { data } = await api.getNoticeBoardDetail(params)

            this.form = { ...data }
        },
        onClickBackToList() {
            this.$emit('backToList')
        },

        async submitForm() {
            const newsType = this.params.newsType

            const newsForm = {
                newsType,
                id: this.form.id,
                name: this.form.DEPOSITOR,
                issueType: this.form.ISSUE_TYPE,
                issueNumber: this.form.ISSUE_NUMBER,
            }

            const result = await api.registAmodifyBoard(newsForm)

            if (result) {
                this.SHOW_ALERT({ content: '무통장 정보가 수정되었습니다.' })
                this.$emit('summited')
            } else {
                this.SHOW_ALERT({ content: '서버 전송에 실패하였습니다.' })
            }
        },
        onClickCheck() {
            this.$emit('canceled')
        },
    },
}
